import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const THROTTLE_MS = 10000;
const lastSent = {};

// Shared state so page-level monitors know what the video player is doing.
export const playbackState = {
  playing: false,
  lectureId: null,
  getTime: () => null,
};

export const reportSecurityEvent = (type, details = {}) => {
  const now = Date.now();
  if (lastSent[type] && now - lastSent[type] < THROTTLE_MS) return;
  lastSent[type] = now;
  axios
    .post(
      `${BACKEND_URL}/api/security/events`,
      {
        type,
        page: window.location.pathname,
        lecture_id: playbackState.lectureId,
        video_time: playbackState.playing ? playbackState.getTime() : null,
        during_playback: playbackState.playing,
        details,
      },
      { withCredentials: true }
    )
    .catch(() => {});
};

// Ask every protected video on the page to pause and hide itself for a moment.
export const obscureContent = (ms = 3000, reason = 'security') => {
  window.dispatchEvent(new CustomEvent('secure:obscure', { detail: { ms, reason } }));
};

export const isTouchDevice = () =>
  typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
